<template>
    <div class="exactCenter" v-if="is_loading">
        <div class="card">
            <div class="card-header">
                <span class="h5 display-6 bold">{{ lang('please_wait') }}</span>
            </div>
            <div class="card-body">
                <vue-spinner :font-size="15" :message="loading_message"></vue-spinner>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapState} from "pinia";
    import * as types from "../../../stores/constants";
    import utilMixin from "../../../utils/mixins";
    import applicationMixin from "../../../utils/application-mixin";
    import NPAppBreadcrumb from "../../../components/np-application-breadcrumb.vue";
    import Spinner from 'vue-simple-spinner';
    import useModuleStore from "../../../stores";
    import useApplicationStore from "../../../stores/application_module";

    export default {
        name: "bankidverify.vue",
        components: {
            'np-application-breadcrumb': NPAppBreadcrumb,
            // 'np-skeleton': NPSkeleton,
            'vue-spinner': Spinner,
        },
        mixins: [applicationMixin, utilMixin],
        data() {
            return {
                page_label: 'loading',
                show_tabs: false,
                loading_message: '',
                is_loading: false,
            }
        },
        metaInfo() {
            return {
                title: this.lang('loading')
            }
        },
        beforeRouteEnter: function (to, from, next){
            console.log('beforeRouteEnter'); //, vm.jsonCopy(vm.matched_packages));
            let current_url = window.location.href;
            let vm_this = this;

            next ( vm => {
                let application_ref = null;
                let owner_ref = null;
                let error_redirect_url = null;
                let verification_type = null;
                let current_action = null;

                if (!!vm.$route.query.state) {
                    let state_array = vm.$route.query.state.split('_');
                    let bankid_value_exists = vm.$route.query.state.split('__').length > 0;
                    application_ref = state_array[0];
                    owner_ref = state_array.length > 1 ? state_array[1] : '';
                    current_action = state_array.length > 2 ? state_array[2] : 'edit';
                    verification_type = bankid_value_exists ? vm.$route.query.state.split('__')[1] : '';
                    // let endpoint = current_action === 'view' ? 'verifyprincipals' : 'principals';
                    //bank id is available on edit mode
                    error_redirect_url = window.location.origin + '/application/' + current_action + '/' + application_ref + '/business_details/principals/';
                }

                if (!!vm.$route.query.error && !!error_redirect_url) {
                    location.href = error_redirect_url;
                    return; //end
                }

                if (!!vm.$route.query.code && !!application_ref && !!owner_ref) {
                    let payload = {
                        'code': vm.$route.query.code,
                        'redirect_uri': current_url.split('?')[0], //window.location.origin + '/application/bankidverify/',
                        'owner_ref': owner_ref,
                        'application_reference': application_ref,
                        'country_code': vm.getIso3FromCountryCode(vm.baseCountryCode),
                        'verification_type': verification_type,
                    };

                    //move to next step.
                    vm[types.SAVE_BANK_ID_PRINCIPAL_DATA](payload).then(response => {
                        if (response && response.data && response.data.result === 'SUCCESS'){
                            vm.notifySuccess(vm.lang('principals_updated_successfully'));
                            //redirect to principal page, fire criipto ajax call
                            vm_this.redirectToPrincipalPage(application_ref, current_action);
                        }
                        else {
                            location.href = error_redirect_url;
                        }
                    }).catch(error => {
                        console.log(error);
                        location.href = error_redirect_url;
                    });
                }
            })
        },

        mounted: function () {

        },
        computed: {
            ...mapState(useModuleStore,{
                user:'user',
                merchant_user_access:'merchant_user_access',
                dashboard:'dashboard',
                parameters:'parameters'}),
        },
        methods: {
            ...mapActions(useApplicationStore, [types.SET_APPLICATION_PAGE_TITLE,types.SAVE_BANK_ID_PRINCIPAL_DATA]),
            setAppPageTitle: function (value) {
                useModuleStore().commit(types.SET_APPLICATION_MODULE + types.SET_APPLICATION_PAGE_TITLE, value);
            },
            toggleShowTabs: function (){
                this.show_tabs = !this.show_tabs;
            },
            redirectToPrincipalPage: function (application_reference, action = 'edit') {
                this.is_loading = true;
                this.loading_message =  this.lang('validate_principal_data');
                let next_path = '/application/';
                if (!!application_reference) {
                    //move to next step.
                    next_path = '/application/' + action + '/' + application_reference + '/business_details/principals/?';
                }
                this.$router.push(next_path);
            },
            updateBankIdPrincipalData: function (payload) {
                console.log('updateBankIdPrincipalData')
                let vm = this;

                // const configs = {
                //     headers: {'X-Requested-With': 'XMLHttpRequest'}
                // };

                vm.showPreloader = true;
                return this.getAxiosInstance().post('/externalservices/retrievebankidprincipaldata', payload)  //, configs)
                    .then(response => {
                        vm.showPreloader = false;
                        const data = response.data;
                    })
                    .catch(error => {
                        vm.showPreloader = false;
                        console.log('error: ', error);
                    });
            },
        }
    }
</script>

<style scoped>
    .text-align-center {
        text-align: center;
    }
</style>